export const CAREPLANS_RECEIVED = 'carePlansReceived'
export const LOADING_CAREPLANS = 'loadingCarePlans'
export const CREATING_CAREPLAN = 'creatingCarePlan'

export const loadingCarePlans = practitionerId => ({
  type: LOADING_CAREPLANS,
  payload: practitionerId
})

export const receiveCarePlans = carePlans => ({
  type: CAREPLANS_RECEIVED,
  payload: carePlans
})

export const createCarePlan = goals => ({
  type: CREATING_CAREPLAN,
  payload: goals
})



// WEBPACK FOOTER //
// ./src/Careplan/actions.js